<h1 class="border-gray border-bottom text-center pb-5 mb-5">Notifications</h1>
<div class="flex-column">
    <div class="d-flex w-100 justify-content-around icon-wrapper">
        <div class="d-flex flex-column align-items-center justify-content-between">
            <img
                routerLink="/account"
                class="icon border-bottom pb-4"
                src="assets/images/icon-profile-avatar.png" />

            <span class="mt-4">Your Profile</span>
        </div>
        <div class="d-flex flex-column align-items-center">
            <img
                class="icon border-bottom pb-4"
                src="assets/images/icon-notification-bell.png" />
            <div class="icon-number-container">
                <span
                    *ngIf="!spinnerConfig.showSpinner"
                    class="mt-4 icon-number p-2"
                    >{{ unreadNotificationsCount }}</span
                >
                <app-inline-spinner [spinnerConfig]="spinnerConfig"></app-inline-spinner>
            </div>
            <span class="mt-4">Notifications</span>
        </div>
        <div class="d-flex flex-column align-items-center">
            <img
                routerLink="/chat"
                class="icon border-bottom pb-4"
                src="assets/images/icon-chat-bubble.png" />
            <div class="icon-number-container">
                <span
                    *ngIf="!spinnerConfig.showSpinner"
                    class="mt-4 icon-number p-2"
                    >{{ chatsAwaitingReplyCount }}</span
                >
                <app-inline-spinner [spinnerConfig]="spinnerConfig"></app-inline-spinner>
            </div>
            <span class="mt-4">Chats Awaiting Reply</span>
        </div>
    </div>
    <div class="d-flex w-100 flex-row-reverse mt-5 mb-5 gap">
        <button
            type="button"
            class="btn btn-warning notification-buttons yellow"
            (click)="confirmAction()"
            >
            Clear All Notifications
        </button>
        <button
            type="button"
            class="btn btn-outline-dark notification-buttons"
            (click)="markAs(false)"
            [disabled]="true">
            Mark All As Unread
        </button>
        <button
            type="button"
            class="btn btn-outline-dark notification-buttons"
            (click)="markAs(true)"
            [disabled]="true">
            Mark All As Read
        </button>
    </div>

    <div class="card border-0 bg-white shadow-sm mb-5 mt-5">
        <div class="card-body">
            <app-table
                *ngIf="notifications"
                [paginationParams]="paginationParams"
                [updatePaginationParams]="updatePaginationParams"
                [tableConfig]="tableConfig"
                [filterForm]="filterControlForm"
                (emitAction)="deleteNotification($event)"
                (emitFilter)="paginate($event)"
                (emitSort)="sort($event)"></app-table>
        </div>
    </div>


</div>




